//Параметры меню

import React from 'react'; 
import './Castom.css'; 
import { useRef } from 'react';
import { InputCounter, Ingredientpoint, InputRadio, InputCheckTools, InputsCals} from '../../atoms'
import { Select, ChoiceMeals, Tabs } from '../../molecules'
import { Popup, ModalInfo } from '../../organisms'
import {nutrients, complex, process, group, tool, hint, recipeErrors, mealsArray} from '../../../constants/constants' 
import {useFormValidation} from '../../../utils/Validator.js'
import {useDispatch, useSelector} from 'react-redux'
import {AutoComplete, useFormErrors, groupedIngredient} from '../../../utils/utils.js'
import { updateUser } from '../../../store/api.js'

export function Castom(props) {
  const { lib, statusLib } = useSelector(state => state.lib) 
  const { currentUser, statusUser } = useSelector(state => state.currentUser)
  const {errors, validate, setError} = useFormErrors()
  const [servings, setServings] = React.useState(1)
  const [time, setTime] = React.useState(60) 
  const [info, setInfo] = React.useState(false) 
  const ingRef =  useRef() 
  const errRef = useRef() 
  const ingAddRef =  useRef()
  const content = props.content
  const dispatch = useDispatch()
  const {ingredients, status} = useSelector(state => state.ingredients)
  const [selectedIngredient, setSelectedIngredient] = React.useState({})
  const [ingredientsData, setIngredientsData] = React.useState([])  
  const [filteredIngredients, setFilteredIngredients] = React.useState([]); 
  const [selectedIngredientAdd, setSelectedIngredientAdd] = React.useState({})
  const [ingredientsAdd, setIngredientsAdd] = React.useState([])  
  const [filteredIngredientsAdd, setFilteredIngredientsAdd] = React.useState([]); 
  const [isOpenComplex, setIsOpenComplex] = React.useState(false)  
  const [meals, setMeals] = React.useState([])
  const [period, setPeriod] = React.useState([])
  const [type, setType] = React.useState([]);
  const [kitchenware, setКitchenware ] = React.useState([]); 
  const [selectedPeriod, setSelectedPeriod] = React.useState('');
  const [selectedNutrients, setSelectedNutrients] = React.useState(''); 
  const [hidden, setHidden] = React.useState(false)
  const [hiddenAdd, setHiddenAdd] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState(false)
  const [isOpenAdd, setIsOpenAdd] = React.useState(false)
  const [except, setExcept] = React.useState([])  
  const typesDisabled = type !== undefined ? type.some(i=> i.boolean ) : false
  const mealsDisabled =  meals.some(item => item && item.boolean && item.dish.every(item => !item.boolean))  || meals.every(i=> i && !i.boolean)
  const min= 1200
  const max= 4000
  const step= 100 
  const [inputFrom,setInputFrom ] = React.useState(min);
  const [inputTo,setInputTo ] = React.useState(max);
  const sliderRef = useRef(null);
  
  const options = [
    { value: 'everyday', label: 'Каждый день' },
    { value: 'two', label: 'Через день' },
    { value: 'three', label: 'Раз в три дня' }, 
  ];
  const { 
    values, 
    handleChange,
    setValues,
  } = useFormValidation({
    protein: 0,
    fats: 0,
    carb: 0,
    minCals: 1200,
    maxCals: 4000,
    complex: '',
  });
  const submitDisabled = props.label1 || !typesDisabled || mealsDisabled

  React.useEffect(() => {
    const click = e => {
      if (isOpen && ingRef.current && !ingRef.current.contains(e.target)  && !e.target.classList.contains('form-castom_list') ) {
        setIsOpen(false) 
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [isOpen])
 
  React.useEffect(() => {
    const click = e => {
      if (info && errRef.current && !errRef.current.contains(e.target) ) {
        setInfo(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
  }, [info])

  React.useEffect(() => {
    const click = e => {
      if (isOpenAdd && ingAddRef.current && !ingAddRef.current.contains(e.target)) {
        setIsOpenAdd(false) 
      } 
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [isOpenAdd])
 
  React.useEffect(() => {
    if(statusLib === 'resolved' && statusUser === 'resolved' && content) {  
      const data = props.user.option.find(o=> o._id === content.id) 
      console.log(data)

      setType(data.typeOfDiet)
      setServings(data.sumFamily)
      setMeals(data.powerMode)   
      setКitchenware(data.kitchenware)
      setSelectedPeriod(data.periodAn)
      setPeriod(data.period)
      setTime(data.cookingTime)
      setIngredientsData(data.stopProducts)
      setIngredientsAdd(data.allowProducts)
      setInputFrom(data.minCals)
      setInputTo(data.maxCals)
      setSelectedNutrients(data.notCals && data.notNutr ? 'normal' : !data.notCals ? 'calories' : !data.notNutr && 'macronutrients' )
      setValues({
        protein: data.macronutrients.protein,
        fats: data.macronutrients.fats,
        carb: data.macronutrients.carb,
        minCals: data.minCals,
        maxCals: data.maxCals,
        complex: data.complex,
      })
      const updatedExcept = lib.except.map(item => {
        // Проверяем, все ли ingredients из текущего элемента есть в stopProduct
        const allIngredientsInStop = item.ingredients.every(ingredientId => 
          data.stopProducts.includes(ingredientId)
        );
        
        return {
          ...item,
          boolean: allIngredientsInStop // Устанавливаем boolean в true если все ингредиенты есть в stopProduct
        };
      });
      
      setExcept(updatedExcept);
  }
  }, [props.user, lib, content]);
 
  console.log(meals)

  const handleCheckBoxMeals = (item) => { 
    setMeals(() => meals.map((c) => c.nameEn === item.nameEn ? item : c)) 
  };

  function filtrSearchArr(arr, keyword, selectedItems) { 
    const keywordSearch = keyword.toLowerCase();
    const availableItems = arr.filter(item => !selectedItems.some(selected => selected === item._id))
    return availableItems.filter(item => 
      item.name.toLowerCase().includes(keywordSearch)
  );
  }
  
  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  const handleNutrientsChange = (event) => {  
    setSelectedNutrients(event.target.value);
  };
 
  function handleTypeClick(item) {   
    setType(() => type.map((c) => c._id === item._id ? {...c, boolean: !item.boolean } : c));
    validate('type', '') 
  }

  const handleAutoSelect = (ingredient) => { 
    setSelectedIngredient({})
    setIngredientsData([...ingredientsData, ingredient._id ]);
    setHidden(false);
    setFilteredIngredients([]);

  };
 
  const handleInputChange = (e) => {
    const {name, value} = e.target; 
    validate(name, value)
    setSelectedIngredient(prev => ({ ...prev, ingredients: value }));
    setHidden(true);
    if (value) {
      setFilteredIngredients(filtrSearchArr(ingredients, value, ingredientsData));
    } else {
      setFilteredIngredients([]);
      setHidden(false)
    }
  };

  function handleDeleteSearch(id) {
    setIngredientsData(prev => prev.filter(c => c !== id));
  }

  const handleAutoSelectAdd = (ingredient) => { 
    setSelectedIngredientAdd({})
    setIngredientsAdd([...ingredientsAdd, ingredient._id]);
    setHiddenAdd(false);
    setFilteredIngredientsAdd([]);

  };
 
  const handleInputChangeAdd = (e) => {
    const {name, value} = e.target; 
    setSelectedIngredientAdd(prev => ({ ...prev, ingredients: value }))
    validate(name, value)
    setHiddenAdd(true);
    if (value) {
      setFilteredIngredientsAdd(filtrSearchArr(ingredients, value, ingredientsAdd));
    } else {
      setFilteredIngredientsAdd([]);
      setHiddenAdd(false)
    }
  };

  function handleDeleteAdd(id) {
    setIngredientsAdd(prev => prev.filter(c => c !== id));
  }

  function handleExpectCheck(item) {   
    setExcept(() => except.map((c) => c.title === item.title ? {...c, boolean: !item.boolean } : c));
    if (item.boolean) {
      // Удаляем ингредиенты из ingredientsData
      setIngredientsData(prevIngredients => 
          prevIngredients.filter(ingredient => !item.ingredients.includes(ingredient))
      );
  } else {
      // Добавляем ингредиенты в ingredientsData
      setIngredientsData(prevIngredients => 
          [...prevIngredients, ...item.ingredients]
      );
  }
 
   } 
 
  const handleSubmit  = async (e) => {
    e.preventDefault();
    const saveOption = {
      sumFamily: servings,
      periodAn: selectedPeriod,
      typeOfDiet: type,
      period: period,
      powerMode: meals,
      cookingTime: Number(time),
      stopProducts: ingredientsData,
      allowProducts: ingredientsAdd,
      kitchenware: kitchenware,
      complex: values.complex,
      maxCals: Number(inputTo),
      notCals: selectedNutrients !== 'calories' ? true : false,
      notNutr: selectedNutrients !== 'macronutrients' ? true : false, 
      macronutrients: {
        protein: values.protein,
        fats: values.fats,
        carb: values.carb,
      },
      minCals:  Number(inputFrom),
      title: content.title,
      id: content.id,
      userId: props.user._id,
    }
    try {
      // Отправка действия и ожидание выполнения
      await dispatch(updateUser(saveOption))  
      // Если обновление прошло успешно, можно закрыть модал
      props.infoModal();
    } catch (error) {
       
    }

   
  };

  const handleIncrease = () => {
    setServings(servings +1) 
  };
  
  // функция для уменьшения значения
  const handleDecrease = () => {
    setServings(Math.max(servings - 1, 1)) 
  }; 
   
  const handleIncreaseTime = () => {
    setTime(Number(time) +5) 
  };
  
  // функция для уменьшения значения
  const handleDecreaseTime = () => {
    setTime(Math.max(Number(time) - 5, 1)) 
  }; 

  function handlePopupModal() {
    setIsOpen(!isOpen)
  }

  function handlePopupAdd() { 
    setIsOpenAdd(!isOpenAdd)
  }

  function handleclosePopup(el) { 
    setIsOpen(false)
  } 

  const handleCheckBoxKitchenware = (e) => {
    const { name, checked } = e.target; 
 
    setКitchenware((tools) => tools.map((c) => c.nameEn === name ? {...c, boolean: checked } : c)); 
  };

  function handleChangeCals(data) {   
    //setValues({min: data.inputFrom, max: data.inputTo})
    setValues((prevData) => ({
      ...prevData, 
      minCals: data.inputFrom, 
      maxCals: data.inputTo
    })); 
  }

  function handleFocus() {
    setIsOpen(!isOpenComplex)
  } 
   
  React.useEffect(() => { 
      if (sliderRef.current===null) return;
      if (inputFrom>inputTo){
          sliderRef.current.style.right = `${100-(inputFrom-min)/(max-min)*100}%`;
          sliderRef.current.style.left = `${(inputTo-min)/(max-min)*100}%`;
      }else{
          sliderRef.current.style.right = `${100-(inputTo-min)/(max-min)*100}%`;
          sliderRef.current.style.left = `${(inputFrom-min)/(max-min)*100}%`;
      }

     /*if (onChange){
          onChange({inputFrom,inputTo});
      } */
  }, [inputFrom, inputTo])
  

  const handleLowerChange = (e) => {
    const value = parseFloat(e.target.value);
    // Проверка, чтобы правый ползунок был не менее чем на 100 больше
    if (value + step <= inputTo) {
        setInputFrom(value);
    }
};

const handleUpperChange = (e) => {
  const value = parseFloat(e.target.value);
  // Проверка, чтобы левый ползунок был не больше чем на 100 меньше
  if (value - step >= inputFrom) {
      setInputTo(value);
  }
};

const handleChangeTime = (e) => {
  setTime(e.target.value)
};
 
  const handleInfo = () => {
    setInfo(!info)
  }
  const getMealsErrorMessage = () => {
    if (meals.every(i => !i.boolean)) {
      return "Не выбран ни один прием пищи";
    }
    return "Для выбранных приемов пищи не указаны блюда";
  };
 
  return (
    <>
    <form onSubmit={handleSubmit} className='form__custom flexColCenter'>
      <fieldset className='form__fieldset_custom '>  
        <label className='recipe__count recipe__count_castom font20Norm'> 
          <span className="form__span_cooking "> </span>
          Количество порций
          <InputCounter handleIncrease={handleIncrease} values={servings} handleDecrease={handleDecrease} name='servings' id='servings'/>
        </label> 
        {/*<div className={`font20EB color form__custom_complex ${isOpenComplex ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocus}> 
          <Select  
            onChange={handleChange}  
            value={values.complex} 
            actions='Сложность блюд'
            name='complex'
            id='complex' 
            lib={complex} 
          />   
  </div>  */}
        <label className='recipe__count recipe__count_time font20Norm'> 
          <span className="gg-timer "> </span>
          Время приготовления до
          <InputCounter handleIncrease={handleIncreaseTime} disabled={false} min='5' handleChange={handleChangeTime} values={time} handleDecrease={handleDecreaseTime} name='time' id='time'/>
          мин
        </label>
      </fieldset>
      <fieldset className='flexColStart'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Тип питания
           </legend>
          {errors.type && <span className="form__text_error font14Norm">{errors.type}</span>}
          </div>
          <div className='form__block_type'>
          {statusLib === 'resolved' &&
            type.map((item, index)=> (
              <button type='button' key={index} onClick={()=>handleTypeClick(item)} className={`buttonType font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            )) 
          }
          </div>
        </fieldset>
        <fieldset className='flexColStart'>
        <legend className='form__legend_period font20EB color'>Как часто Вы готовите?  </legend> 
            <InputRadio
              options={options}
              selectedValue={selectedPeriod}
              onChange={handlePeriodChange}
              name='period'
            />
        </fieldset>
        <ChoiceMeals types={meals} settingDinner={props.settingDinner} handleCheckBox={handleCheckBoxMeals}/>
        <fieldset className='flexRowStart form-castom__product-fieldset'>  
          <div className='flexColStart form__ingredient_block'>  
            <p className='font20EB color form-castom__product-title'>Продукты, которые следует исключить </p>
            <p className='font20Norm colorGrey form-castom__product-subtitle'>Выберите группу или продукты которые не должны быть в плане </p>
          <div className='form__block_type'>
            {statusLib === 'resolved' &&
              except.map((item, index)=> (
                <button type='button' key={index} onClick={()=>handleExpectCheck(item)} className={`buttonType font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.title}</button>
              )) 
            }
          </div>
          <div className='form__data_add-ingredient'>
            <label className='form__label form__label_ingredient font20EB color'> 
              <input 
                type='text'  
                title='' 
                onChange={handleInputChange}
                onFocus={props.onFocus} 
                placeholder= 'Начните вводить ингредиент'
                value={selectedIngredient.ingredients || ''}
                name='ingredients' 
                id='ingredients'  
                autocomplete="off"
                className={`form__input font20Norm ${errors.ingredients ? 'form__error' : ''}`}
                aria-describedby={`${props.name}-error`} 
              />  
              {errors.ingredients ? <span className="form__text_error font14Norm">{errors.ingredients}</span>
              :
              <div className={`add-recipe__autocomplete ${hidden ? 'add-recipe_hidden' : ''}`} >
                {filteredIngredients.length > 0 && hidden ?  
                  filteredIngredients.map((item, index) => (
                    <AutoComplete key={index} item={item} onClick={handleAutoSelect} />
                  ))
                : filteredIngredients.length === 0 ? 
                <p className='form__text_error font14Norm autocomplete_none'>Ингредиент не найден</p>
                 : null} 
              </div>}
            </label> 
            
            </div>
            <div className='form-castom__product'>
            {ingredientsData.length > 0 &&
            <Popup isOpen={isOpen} ref={ingRef} type='ing-list'>
                {ingredientsData.map((el, index) => (
                   <Ingredientpoint onDelete={handleDeleteSearch} item={el} key={index}/>
                ))}  
             </Popup> 
            }
            <button type='button' className='form-castom_list buttonGreen' onClick={handlePopupModal}>Список продуктов<span className='form-castom_count font12Norm'>+ {ingredientsData.length}</span>
             </button>  
             </div>
            </div>
         {/*<div className='flexColStart form__ingredient_block'>  
          <p className='font20EB color'>Продукты, которые следует использовать </p>
          <p className='font20Norm colorGrey'>Добавьте продукты, которые обязательно  должны присутствовать в меню </p>
       
          <div className='form__data_add-ingredient'>
            <label className='form__label form__label_ingredient font20EB color'> 
              <input 
                type='text'  
                title='' 
                onChange={handleInputChangeAdd}
                onFocus={props.onFocus} 
                value={selectedIngredientAdd.ingredients || ''}
                placeholder= 'Начните вводить ингредиент'
                name='ingredients-add' 
                id='ingredients-add'  
                autocomplete="off"
                className={`form__input font20Norm ${errors.ingredients ? 'form__error' : ''}`}
                aria-describedby={`${props.name}-error`} 
              />  
              {errors['ingredients-add'] ? <span className="form__text_error font14Norm">{errors['ingredients-add']}</span>
              :
              <div className={`add-recipe__autocomplete ${hiddenAdd ? 'add-recipe_hidden' : ''}`} >
                {filteredIngredientsAdd.length > 0 && hiddenAdd ?  
                  filteredIngredientsAdd.map((item, index) => (
                    <AutoComplete key={index} item={item} onClick={handleAutoSelectAdd} />
                  ))
                : filteredIngredientsAdd.length === 0 ? 
                <p className='form__text_error font14Norm autocomplete_none'>Ингредиент не найден</p>
                 : null} 
              </div>}
            </label>
          
            </div>
            <div className='form-castom__product'>
            {ingredientsAdd.length > 0 &&
              <Popup isOpen={isOpenAdd} ref={ingAddRef} type='ing-list'>
                {ingredientsAdd.map((el, index) => (
                  <Ingredientpoint onDelete={handleDeleteAdd} item={el} key={index}/>
                ))}  
             </Popup> 
            } 
          <button type='button' className='form-castom_list buttonGreen' onClick={handlePopupAdd}>Список продуктов<span className='form-castom_count font12Norm'>+ {ingredientsAdd.length}</span></button>  
            </div></div>
       */} 
       </fieldset> 
      <fieldset className='flexColStart'>
        <legend className='form__legend_period font20EB color'> Оборудование на кухне</legend>
        <div className='form-castom__tools'>
          {kitchenware.length> 0 &&
            kitchenware.map((item)=> (
              <InputCheckTools checked={item.boolean} onChange={handleCheckBoxKitchenware} key={item._id} item={item} name={item.nameEn}/>
            ))
          }
        </div>
      </fieldset>
      <fieldset className='flexColStart'>
      <legend className='form__legend_period font20EB color'>Ограничьте калорийность или бжу</legend> 
      <div className='flexRowSB'>
      <div className='nutrients__block widt45'>
      <label   className='radio__label font20Norm' >
          <input type="radio" value={'normal' || ''} checked={selectedNutrients === 'normal'} className='radio__checkbox' onChange={handleNutrientsChange} name='nutrients' id='normal' />
          <span className="visible-checkbox item__link"></span>
          Не ограничивать
        </label>
      </div>
       <InputsCals
        options={nutrients}
        type= 'cals'
        selectedValue={selectedNutrients}
        onChange={handleNutrientsChange}
        name='nutrients' 
        handleChange={handleChangeCals}
        handleChanges={handleChange}
        values={values} 
        handleUpperChange={handleUpperChange}
        handleLowerChange={handleLowerChange}
        inputFrom={inputFrom}
        inputTo={inputTo}
        sliderRef={sliderRef}
      />
      </div> 
      </fieldset>
      <div className='df-r castom__button'>
      <button type='submit' className={`buttonGreen ${submitDisabled  ? ('buttonDisabled') : ''}`} disabled={submitDisabled}>Cохранить изменения</button>
      {/* Кнопка с восклицательным знаком при наличии ошибки */}
  {submitDisabled && (
    <button 
      type="button" 
      className="gg-note error-tooltip" 
      onClick={handleInfo}
      aria-label="Показать информацию об ошибке"
    />
  )}

  {/* Попап с информацией об ошибках */}
  {info && ( 
    <Popup isOpen={info} type='error-info' ref={errRef}>
      <div className="error-messages">
        {props.label1 && <p>• {props.label1}</p>}
        
        {!typesDisabled && (
          <p>• Необходимо выбрать хотя бы один тип блюда</p>
        )}
        
        {mealsDisabled && (
          <p>• {getMealsErrorMessage()}</p>
        )}
      </div>
    </Popup>
  )}
      </div> 
      </form>
  
    </>
   
  ) 
}
